(function(angular){
	'use strict';

	angular
		.module('plaidModule')
		.factory('PlaidFactory', [
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'plaidConfig',
			'urlFactory',
			PlaidFactoryFunction
		]);

	function PlaidFactoryFunction(
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		plaidConfig,
		urlFactory) {
		var factory = {
			getPlaid: getPlaid,
		};

		return factory;

		function getPlaid(successCallback, errorCallback, exitCallback) {
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/account/link-plaid-account';

			return Plaid.create({
				clientName: 'Fundrise Website',
				env: plaidConfig.environment,
				key: plaidConfig.publicKey,
				product: ['auth'],
				selectAccount: true,
				onSuccess: function(public_token, metadata) {
					var data = {
						'publicToken': public_token,
						'selectedAccountId': metadata.account.id,
						'institutionName': metadata.institution.name
					};

					urlFactory.apiPostPromise(url, data)
						.then(function(linkedAccount) {
							successCallback(linkedAccount.data);
						})
						.catch(function() {
							errorCallback();
						});
				},
				onEvent: function(eventName, metadata) {
					sendEventToMixpanelIfNecessary(eventName, metadata);
				},
				onExit: function(error, metadata) {
					exitCallback(metadata.status);
				}
			});
		}

		function sendEventToMixpanelIfNecessary(eventName, metadata) {
			mixpanelFactory.track("Plaid Link Event " + eventName, buildEventPropertiesJson(eventName, metadata));
		}

		function buildEventPropertiesJson(eventName, metadata) {
			var properties = {};

			properties["Plaid Institution Name"] = getMetadataValueForMixpanel(metadata.institution_name);
			properties["Plaid Error Code"] = getMetadataValueForMixpanel(metadata.error_code);
			properties["Plaid Error Message"] = getMetadataValueForMixpanel(metadata.error_message);
			properties["Plaid Error Type"] = getMetadataValueForMixpanel(metadata.error_type);
			properties["Plaid Exit Status"] = getMetadataValueForMixpanel(metadata.exit_status);
			properties["Plaid Institution Search Query"] = getMetadataValueForMixpanel(metadata.institution_search_query);
			properties["Plaid View"] = getMetadataValueForMixpanel(metadata.view_name);
			properties['Plaid MFA Type'] = getMetadataValueForMixpanel(metadata.mfa_type);

			return properties;
		}
		
		function getMetadataValueForMixpanel(value) {
			if (value === null) {
				return undefined;
			}
			else {
				return value;
			}
		}
		
	}
})(window.angular);